import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Icon } from '../common/Icons';
import ArticleHeader from '../Heading/Heading';
import Wrapper from '../common/Wrapper/Wrapper';
import {
  StyledSection,
  StyledTabList,
  StyledTabItem,
  StyledTabButton,
  StyledQuestionList,
  StyledContentItem,
  StyledLikeButton,
  StyledTemporaryWrapper,
} from './InfoTabs.styles';
import SearchBar from '../SearchBar/SearchBar';

function InfoTabs({ data, onQuestionLike }) {
  const [activeTab, setActiveTab] = useState(1);
  const [storage, setStorage] = useState([]);

  const onClick = id => {
    setActiveTab(id);
  };

  const updateStorage = () => {
    setStorage(JSON.parse(localStorage.getItem('savedQuestions')));
  };

  useEffect(() => {
    updateStorage();
  }, []);

  const onQuestionClick = item => {
    onQuestionLike(item);
    updateStorage();
  };

  if (!Object.entries(data).length) return null;

  return (
    <StyledSection>
      <Wrapper>
        <ArticleHeader
          title={data.title ? data.title : 'Suggested questions'}
          icon={<Icon.Question aria-hidden />}
          type="h2"
          styling="font-14-semi-bold"
        />
        <StyledTabList>
          {data.questions &&
            data.questions.map(item => (
              <StyledTabItem key={item.id}>
                <StyledTabButton
                  type="button"
                  active={item.id === activeTab}
                  className={item.id === activeTab ? 'active' : null}
                  onClick={() => onClick(item.id)}
                >
                  {item.title}
                </StyledTabButton>
              </StyledTabItem>
            ))}
        </StyledTabList>
        {/* TODO: Delete this wrapper */}
        <StyledTemporaryWrapper>
          <SearchBar searchQuery={() => {}} info />
        </StyledTemporaryWrapper>
        <StyledQuestionList>
          {data.questions && data.questions.filter(item => item.id === activeTab).length
            ? data.questions
                .find(item => item.id === activeTab)
                .questions.map((item, key) => (
                  <StyledContentItem key={key}>
                    {item}
                    <StyledLikeButton type="button" onClick={() => onQuestionClick(item)}>
                      {storage
                        .map(element => {
                          if (
                            element.questions &&
                            element.questions.some(question => question === item)
                          ) {
                            return true;
                          }

                          return false;
                        })
                        .some(element => element !== false) ? (
                        <Icon.HeartBig aria-hidden />
                      ) : (
                        <Icon.HeartOutline aria-hidden />
                      )}
                    </StyledLikeButton>
                  </StyledContentItem>
                ))
            : null}
        </StyledQuestionList>
      </Wrapper>
    </StyledSection>
  );
}

InfoTabs.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        questions: PropTypes.arrayOf(PropTypes.string).isRequired,
      })
    ),
  }),
};

InfoTabs.defaultProps = {
  data: {},
};

export default InfoTabs;
